import React from 'react';
import type { DescriptionsProps } from 'antd';
import { Descriptions, Divider, Typography } from 'antd';
import type { ClientRes, ContactRes } from 'api/swagger';
import { ClientTypeTag } from 'components/clients/client-type-tag';

interface IOrderFormConclusionProps {
  client?: ClientRes;
  contact?: ContactRes;
}

const { Text } = Typography;

export const OrderFormConclusion: React.FC<IOrderFormConclusionProps> = (props) => {
  const { client, contact } = props;

  if (!client) return null;

  const clientItems: DescriptionsProps['items'] = [
    {
      key: 'client',
      label: 'Client',
      children: (
        <>
          <Text>
            <Text strong>{client?.shortName} </Text>
            {client?.name}
          </Text>
        </>
      ),
    },
    {
      key: 'vat_number',
      label: 'Vat number',
      children: client?.vatNumber,
    },
    {
      key: 'type',
      label: 'Type',
      children: <ClientTypeTag type={client?.type} isVip={client?.isVip} />,
    },
  ];

  const contactItems: DescriptionsProps['items'] = [
    {
      key: 'name',
      label: 'Contact',
      children: (
        <Text>
          <Text strong>{contact?.name} </Text> {contact?.role}
        </Text>
      ),
    },
    {
      key: 'phone',
      label: 'Phone',
      children: contact?.phone,
    },
    {
      key: 'email',
      label: 'Email',
      children: contact?.email,
    },
  ];

  return (
    <>
      <Divider />
      <Descriptions column={1} size='small' items={clientItems} />
      {contact ? <Descriptions column={1} size='small' items={contactItems} /> : null}
    </>
  );
};
